import { useContext } from "react"
import { WebsocketContext } from "../utils/websocketProvider"

export default function useWebsocket() {
    const websocket = useContext(WebsocketContext);
    return websocket;
}